import * as React from 'react';

import * as styles from './styles.css';
import { GroupJobs } from '../../../../components/GroupJobs';
import { IDepartamentGroupSchema } from '../../../../common/repositories/job-vacancies-backend/entities/vacancies_listing/DepartamentGroupSchema';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

export interface IVacanciesProps {
  groupsJobs: IDepartamentGroupSchema[];
}

export const Vacancies: React.FC<IVacanciesProps> = ({ groupsJobs }) => {
  const deviceType = useDeviceType();

  return (
    <ul className={cn(styles.root, styles[deviceType])}>
      {groupsJobs.map(({ title, vacancies, count }) => (
        <li key={title} className={cn(styles.item, styles[deviceType])}>
          <GroupJobs title={title} vacancies={vacancies} count={count} />
        </li>
      ))}
    </ul>
  );
};

Vacancies.displayName = 'Vacancies';
